import { render, staticRenderFns } from "./dashboardCardView.vue?vue&type=template&id=0ff9cf8c&scoped=true"
import script from "./dashboardCardView.vue?vue&type=script&lang=js"
export * from "./dashboardCardView.vue?vue&type=script&lang=js"
import style0 from "./dashboardCardView.vue?vue&type=style&index=0&id=0ff9cf8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff9cf8c",
  null
  
)

export default component.exports